import { render, staticRenderFns } from "./AccordionItemEdit.vue?vue&type=template&id=7dccbcdf&"
import script from "./AccordionItemEdit.vue?vue&type=script&lang=js&"
export * from "./AccordionItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports